<template>
	<v-card
		class="rounded-t-lg mt-1 ride-resume"
		outlined
		:style="styleObject"
		:ref="'service' + service.id"
	>
		<v-toolbar flat dense>
			<v-toolbar-title class="font-weight-black"
				>SERVICE #{{ service.serviceNumber }}
				<v-tooltip v-if="isClientConfirmed(service)" bottom>
					<template v-slot:activator="{ on, attrs }" >
						<v-icon
						v-bind="attrs"
						v-on="on"
						color="green"
						class="ml-1"
						style="font-size: 24px; cursor: pointer;"
						>
							verified
						</v-icon>
					</template>
					<span>{{ $t("global.confirm") }}</span> 
				</v-tooltip>
			</v-toolbar-title>
			
			<v-spacer></v-spacer>
		</v-toolbar>
		
		<!-- Overlay if service is done -->
		<div
			v-if="isServiceDone(service)"
			class="overlay-done d-flex align-center justify-center"
		>
			<div class="text-h6 font-weight-bold white--text">
				<v-icon
				color="green"
				class="ml-1"
				style="font-size: 24px; cursor: pointer;"
				>
					done
				</v-icon>
				<br>
				{{ $t("section.traveler.rideDone") }}
			</div>
		</div>
		<!-- Overlay if service is done -->

		<v-row v-if="!isServiceDone(service)" class="checkin-section">
			<v-col class="text-center">
				<div>
					<div class="edit-section">
						<v-tooltip
						color="primary"
						:disabled="!showTooltip"
						v-model="showTooltip"
						bottom
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-bind="attrs"
									v-on="on"
									elevation="0"
									class="font-weight-bold mr-n3"
									small
									:dark="darkStyle"
									:color="darkStyle ? 'primary' : 'primary100'"
									rounded
									@click="toRoute(service)"
									> {{ textButton(service) }}
										<v-icon small class="ml-1">edit_note</v-icon>
										<v-icon  class="ml-1" style="color:#f7bb7f" v-if="false">new_releases</v-icon>
									</v-btn
									
								>
							</template>
							<span
								class="d-flex text-center white--text subtitle-2 font-weight-bold"
								>{{ $t("global.tooltipEdit") }}
							</span>
						</v-tooltip>
					</div>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="service.canShowTrackingUrl">
			<v-col>
				<TrackingPortalLink :ride="service"></TrackingPortalLink>
			</v-col>
		</v-row>
		<v-row>
			<v-col
				cols="12"
				class="d-flex justify-center secondary--text font-weight-bold text-h6 mt-2 mb-n3"
			>
				<div>{{ clientName }}</div>
			</v-col>
			<v-col cols="12">
				<LayoutBase
					:dark="darkStyle"
					:title="t('pickupDropOff.reservationNumber')"
				>
					<CardReservationNumber :service="service" confirm-mode />
				</LayoutBase>
			</v-col>
			<v-col cols="12">
				<LayoutBase :dark="darkStyle" :title="t('pickupDropOff.title')">
					<LayoutCard
						@click="scrollEdit(service)"
						icon="hail"
						:title="t('pickupDropOff.form.pickup.location')"
						>{{ pickupfullName(service) }}</LayoutCard
					>
					<LayoutCard
						@click="scrollEdit(service)"
						class="mt-3"
						icon="location_on"
						:title="t('pickupDropOff.form.dropOff.location')"
						>{{ dropofffullName(service) }}</LayoutCard
					>
				</LayoutBase>
			</v-col>
			<v-col cols="12" v-if="existAirport(service)">
        <LayoutBase :dark="darkStyle" :title="t('flight.title')">
				<LayoutFlight
					@click="scrollEdit(service)"
					:flightNumber="`${service.flightNumber} ${airline(service)}`"
					:flightTime="service.flightDatetime"
				/>
				</LayoutBase>
			</v-col>
			<v-col cols="12">
				<LayoutBase :dark="darkStyle" :title="t('schedule.title')">
          <LayoutDateTime
            @click="scrollEdit(service)"
            :flightTime="service.flightDatetime"
            :pickupTime="service.pickupDatetime"
            :pickupTimeLimit="service.pickupDatetimeLimit"
            :dateTitle="t(flightDateTitle(service))"
            :timeTitle="t(flightTimeTitle(service))"
          />
				</LayoutBase>
			</v-col>
			<v-col cols="12" class="mb-n1">
				<LayoutBase
					:dark="darkStyle"
					:title="t('passenger.titleConfirm')"
				>
					<CardTransferType
						@click="scrollEdit(service)"
						:serviceType="service.serviceType.name"
						:adults="reservationModel.adults"
						:children="reservationModel.children"
						:infants="reservationModel.infants"
						confirm-mode
						dense
					/>
				</LayoutBase>
			</v-col>
			<v-col cols="12" class="mb-2">
				<LayoutBase
					:dark="darkStyle"
					:title="t('confirmation.form.specialRequest')"
				>
					<v-card elevation="0" width="100%" class="rounded-lg">
						<v-textarea
							height="100%"
							readonly
							hide-details=""
							dense
							:value="service.clientNote"
							outlined
							@click="scrollEdit(service)"
							:placeholder="
								t('confirmation.form.specialRequestPlaceholder')
							"
						></v-textarea>
					</v-card>
				</LayoutBase>
				<div class="mx-3 mt-1 caption font-weight-thin">
					{{ t("confirmation.form.specialRequestMessage") }}
				</div>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import LayoutBase from "@/layouts/LayoutBase";
import LayoutCard from "@/layouts/LayoutCard";
import LayoutDateTime from "@/layouts/LayoutDateTime";
import LayoutFlight from "@/layouts/LayoutFlight";
import CardTransferType from "@/components/card/CardTransferType";
import CardReservationNumber from "@/components/card/CardReservationNumber";
import TrackingPortalLink from "./TrackingPortalLink.vue";
import { mapActions, mapState } from "vuex";
export default {
	components: {
		LayoutBase,
		LayoutCard,
		LayoutDateTime,
    LayoutFlight,
		CardTransferType,
		CardReservationNumber,
		TrackingPortalLink
	},
	props: {
		service: Object,
		darkStyle: Boolean
	},
	data: () => ({
		styleObject: { border: "2px dashed #4F39CF" },
		showTooltip: false
	}),
	computed: {
		...mapState("reservation", ["reservationModel"]),
		clientName: vm => vm.reservationModel?.client?.fullName || "",
	},
	methods: {
		...mapActions("service", ["_openCheckin","_openEditingRide"]),
		airline: service => service.flightValidationData?.airline || "",
		pickupfullName: service => service.pickup?.fullName || "",
		dropofffullName: service => service.dropoff?.fullName || "",
		isClientConfirmed(service) {
			return service.locked === "client";
		},

		async toRoute(service) {
			this._openCheckin(service.id);
		},
		isArrival(service) {
			return service.pickup?.isAirport ? true : false;
		},
		existAirport(service) {
			return service.pickup?.isAirport || service.dropoff?.isAirport;
		},
		scrollEdit(service) {
			this.$vuetify.goTo(this.$refs["service" + service.id]);
			setTimeout(() => (this.showTooltip = true), 1000);
		},
		flightDateTitle: service =>
			service.pickup?.isAirport
				? "flight.form.arrivalDate"
				: "flight.form.takeoffDate",
		flightTimeTitle: service =>
			service.pickup?.isAirport
				? "flight.form.arrivalTime"
				: "flight.form.takeoffTime",
		t(key, options = {}) {
			return this.$t(`section.${key}`, options);
		},
		editClicked(){
			this._openEditingRide(this.service.id)
		},
		isServiceDone(service) {
			return service.status === "done" || service.status === "noShow";
		},
		textButton(service) {
			if (service.locked === "client") {
				return this.$t("global.confirm");
			}
			if (service.attribs.checkinWindow) {
				return this.$t("global.btnEditOrConfirm");
			}
			return "Edit";
		}

	}
};
</script>

<style>
.overlay-done {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.4);
	z-index: 10;
	border-radius: 8px; /* match your card's rounded corners */
	pointer-events: none;
	text-align: center;
}



</style>
